import { useCallback } from "react"
import { useLocalizacaoApi } from "../../../infra/geo-veles"
import { useAppDispatch, useAppSelector } from "../../../presentation/hooks/store-hooks"
import { resetLocalizacaoInitialState, resetLocalizacaoSearchTermState, setLocalizacaoCategoriaState, setLocalizacaoSearchTermState, setLocalizacoesState, setOpenLocalizacaoDialogState } from "../../../application/states/geo-veles"
import { ILocalizacao } from "../../../application/models"
import { useUIService } from "../../ui"

export const useLocalizacaoService = () => {
    // Dispatch
    const dispatch = useAppDispatch()
    // State
    const { localizacao } = useAppSelector((state) => state)
    // Hook
    const { setAlert } = useUIService()
    // API
    const { getLocalizacaoBySearchTermApi } = useLocalizacaoApi()

    // Hooks
    const setSearchTerm = useCallback((searchTerm: string) => {
        dispatch(setLocalizacaoSearchTermState({
            searchTerm: searchTerm
        }))
    }, [dispatch])

    const setCategoria = useCallback((categoria: keyof ILocalizacao) => {
        dispatch(setLocalizacaoCategoriaState({
            categoria: categoria
        }))
    }, [dispatch])

    const searchLocalizacao = useCallback(async () => {
        try {
            if (localizacao.searchTerm.length > 0) {
                const findLocalizacao = await getLocalizacaoBySearchTermApi({
                    searchTerm: localizacao.searchTerm,
                    categoria: localizacao.categoria
                })

                dispatch(setLocalizacoesState({
                    localizacoes: findLocalizacao
                }))
            }

        } catch (error: any) {
            setAlert({
                message: error.response.data.error,
                type: 'error'
            })
        }
    }, [dispatch, getLocalizacaoBySearchTermApi, localizacao.categoria, localizacao.searchTerm, setAlert])

    const resetLocalizacoesList = useCallback(() => {
        dispatch(setLocalizacoesState({
            localizacoes: []
        }))
    }, [dispatch])

    const openLocalizacaoDialog = useCallback((openDialog: boolean) => {
        dispatch(setOpenLocalizacaoDialogState(openDialog))
    }, [dispatch])

    const resetLocalizacaoSlice = useCallback(() => {
        dispatch(resetLocalizacaoInitialState())
    }, [dispatch])

    const resetLocalizacaoSearchTerm = useCallback(() => {
        dispatch(resetLocalizacaoSearchTermState())
    }, [dispatch])

    return {
        setSearchTerm,
        searchLocalizacao,
        setCategoria,
        resetLocalizacoesList,
        openLocalizacaoDialog,
        resetLocalizacaoSlice,
        resetLocalizacaoSearchTerm
    }
}